
addEventListener('DOMContentLoaded', () => {
    const section = document.getElementById('kennisbank')
    if (!section) {
        return
    }
    
    const listItems = section.querySelectorAll('div.list-block div.item')
    const forms = document.querySelectorAll('div.dynamicform-block[id]')

    // kennisbank works by matching forms with listitems, then adding a button
    // to show or hide the corresponding form.

    const toggleForm = (formElement) => {
        const becomesVisble = formElement.classList.toggle('visible')
        const newHeight = becomesVisble ? formElement.scrollHeight  : 0
        formElement.style.maxHeight = newHeight + 'px'
    }

    for (const item of listItems) {
        // update link
        const anchor = item.querySelector('a.title')
        const targetId = anchor.getAttribute('href').split('/').pop()
        const form = [...forms].find(item => item.id === targetId)
        anchor.setAttribute('href', '#')

        if (!form) {
            // missing form
            anchor.addEventListener('click', (e) => e.preventDefault())

            const title = anchor.querySelector('span').textContent
            console.error(`No form element found for document '${title}'. Expecting a form cell with id '${targetId}'.`)
            continue;
        }

        // add a cta button
        const button = document.createElement('a')
        button.className = 'cta secondary'
        button.textContent = localized.file.documentCta

        const onClick = (e) => {
            e.preventDefault()
            form && toggleForm(form)
        }

        button.addEventListener('click', onClick)
        anchor.addEventListener('click', onClick)
        item.appendChild(button)

        // reposition the form in the dom
        form.remove()
        item.appendChild(form)
    }
})